import {useState,} from "react";
import {IDetailBooking} from "../../utils/interfaces/IDetailBooking";
import {convertToEuropeanFormat} from "../../logics/helpers";

interface DetailBookingRowProps {
    obj: IDetailBooking,
}

function DetailBookingRow({obj: initialObj}: DetailBookingRowProps) {
    const [obj, setObj] = useState<IDetailBooking>(initialObj)

    return (
        <>
            <td className="mycia_td">
                {convertToEuropeanFormat(obj.reserved_at)}
            </td>
            <td className="mycia_td">
                {obj.reserved_time}
            </td>
            <td className="mycia_td">
                {obj.seats}
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.seat_price.toFixed(2)}</span>
                <span>€</span>
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.nett_price.toFixed(2)}</span>
                <span>€</span>
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.vat.toFixed(2)}</span>
                <span>€</span>
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.gross_price.toFixed(2)}</span>
                <span>€</span>
            </td>
        </>
    )
}

export default DetailBookingRow;